var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{ref:"list",attrs:{"menuMetadataConfigId":_vm.menuMetadataConfigId}})}
var staticRenderFns = []

export { render, staticRenderFns }